import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { CandidateJobMatchCardComponent } from './candidate-job-match-card.component';
import { CandidateCardIconsModule } from 'src/app/shared/candidate-card-icons/candidate-card-icons.module';
import { RecentActivitiesModule } from 'src/app/shared/recent-activities/recent-activities.module';
import { NotificationsPageModule } from 'src/app/pages/mission-control-page/notifications-page/notifications-page.module';
import { PipesModule } from 'src/app/core/pipes/pipes.module';

@NgModule({
  declarations: [CandidateJobMatchCardComponent],
  imports: [
    CommonModule,
    TooltipModule.forRoot(),
    PopoverModule.forRoot(),
    CandidateCardIconsModule,
    RecentActivitiesModule,
    NotificationsPageModule,
    PipesModule
  ],
  exports: [CandidateJobMatchCardComponent],
  entryComponents: [CandidateJobMatchCardComponent]
})
export class CandidateJobMatchCardModule { }
